import React, { useEffect, useRef, useState } from "react";
import { FaCamera } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "../../CSS/RegisterEmployee.css";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import LoadingScreen from "../LoadingScreen";

import { useDispatch, useSelector } from "react-redux";
const EmployeeMaster = () => {
  const [isloading, setisloading] = useState(true);
  const useSelect = (initialState) => {
    const [selectedOption, setSelectedOption] = useState(initialState);

    const handleSelectChange = (selectedOption) => {
      setSelectedOption(selectedOption.value);
    };

    return [selectedOption, handleSelectChange];
  };

  const state = useSelector((state) => state.changeTheState);
  const LoggedInUserName = state?.user?.emailId?.split("@")[0];
  const navigate = useNavigate();
  // const axiosJWT = JwtRequestHandler();
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  //   const BASEURL = process.env.REACT_APP_BASEURL;
  // const BASEURL = import.meta.env.VITE_REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const initialValues = {
    EMPCODE: "",
    EMPNAME: "",
    ACCOUNTNO: "",
    // JOINDATE: "",
    NATIONALID: "",
    TELEPHONE: "",
    EMAIL: "",
    OVERTIME: 0,
    FREEZE: 0,

    CASUAL: 1, // Default to Yes (1)
    SUBCONTRACTED: 0, // Default to No (0)

    IMAGENAME: "",
    CONFIRM: 0,
    NOTES: "",
    PORTPASS: 0,
    PORTPASSNO: "",
    // PORTPASSEXPIRY: "",
  };

  const [formInput, setFormInput] = useState(initialValues);
  const [JOINDATE, setJOINDATE] = useState(new Date().toISOString());
  const [PORTPASSPORTPASSEXPIRY, setPORTPASSPORTPASSEXPIRY] = useState("");
  const [section1, setSection1] = useState(true);
  const [desigVal, setDesigVal] = useState([]);
  const [DEPARTMENTVal, setDEPARTMENTVal] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [dispPicture, setDispPicture] = useState("");
  const [picture, setPicture] = useState(null);
  const [cameraOn, setCameraOn] = useState(false);
  const [captured, setCaptured] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [fileUpload, setFileUpload] = useState(null);
  const [filePreview, setFilePreview] = useState(false);
  const [hide, sethide] = useState(true);
  const [empidPass, setEmpId] = useState("");
  const [designation, setDesignation] = useSelect("");
  const [department, setDepartment] = useSelect("");
  const [vehicleAllocated, setVehicleAllocated] = useSelect("");
  const [previousDesignation, setPreviousDesignation] = useState("");
  const [image, setImage] = useState("");

  const [employeeList, setEmployeeList] = useState([]);
  const [showEmployees, setShowEmployees] = useState(false);
  const [searchEmployees, setSearchEmployees] = useState("");

  const filterEmployee = employeeList?.filter((item) => {
    const searchData = searchEmployees
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        " EMPLOYEE ID",
        "EMPLOYEE CODE",
        "EMPLOYEE NAME",
        "NATIONAL ID NO",
        "TELEPHONE NO",
        "DESIGNATION",
        "DEPARTMENT",
        "EMAIL",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Reset vehicleAllocated if designation changes
  useEffect(() => {
    if (previousDesignation && designation !== "DRIVER") {
      setVehicleAllocated("");
    }
    setPreviousDesignation(designation);
  }, [designation, previousDesignation]);
  const handleInputItem = (e) => {
    const { name, value } = e.target;
    setFormInput({ ...formInput, [name]: value });
  };

  const handleClickItem = (name, value) => {
    setFormInput({ ...formInput, [name]: value });
  };

  function masterData() {
    setisloading(true);
    //
    //
    axios
      // .get(`${BASEURL}/getNewEmployeeID`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=381`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setisloading(false);
        setEmpId(response.data[0].EMPID);
      })
      .catch((err) => {
        console.log("error while fetching 381");
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1727`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setFormInput({ ...formInput, EMPCODE: response?.data[0]?.EMPCODE });
      })
      .catch((err) => {
        console.log("error while fetching 1727");
      });

    //
    axios
      // .get(`${BASEURL}/getListOfVehicles`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setisloading(false);
        setVehicles(response.data);
      })
      .catch((err) => {
        console.log("error while fetching 671");
      });

    axios
      // .get(`${BASEURL}/getEmployeeDepartment`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=347`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setisloading(false);
        setDEPARTMENTVal(response.data);
      })
      .catch((err) => {
        console.log("error while fetching 347");
      });

    axios
      // .get(`${BASEURL}/getEmployeeDesignation`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=348`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setDesigVal(response.data);
      })
      .catch((err) => {
        console.log("error while fetching 348");
      });

    // Saved Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=611`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => a?.[" EMPLOYEE ID"] - b?.[" EMPLOYEE ID"],
        );
        setEmployeeList(sortedData);
        setisloading(false);
      })
      .catch((err) => {
        console.log("error while fetching 611");
      });
  }
  useEffect(() => {
    masterData();
  }, []);

  function tofixnumber(e) {
    const input = e.target;
    const TELEPHONE = input.value.replace(/\D/g, "");

    if (TELEPHONE.length > 15) {
      const givenvalue = TELEPHONE.replace(/(\d{15})/);
      input.value = givenvalue;
    }
  }

  const openCamera = async () => {
    setSection1(false);
    setCameraOn(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (error) {
      // Handle the error or show a message to the user
    }
  };

  const capturePicture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !video.srcObject) {
      return;
    }

    // Rest of the code for capturing the picture
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);

    const pictureData = canvas.toDataURL();
    canvas.toBlob((blob) => {
      setPicture(blob);
    });
    setDispPicture(pictureData);

    // Stop video tracks
    const videoTracks = video.srcObject.getTracks();
    videoTracks.forEach((track) => track.stop());

    setCaptured(true);
    setCameraOn(false);
  };

  const retakePicture = () => {
    setPicture(null);
    setDispPicture("");
    setCaptured(false);
    openCamera();
  };
  async function handlePictureUpload(e) {
    const file = e.target.files[0];
    setPicture(file);

    const imageURL = URL.createObjectURL(file);
    const images = await uploadImage(file);
    setImage(images);
    setDispPicture(imageURL);
  }

  console.log(image);

  const uploadImage = async (file) => {
    try {
      const formData = new FormData();
      formData.append("imageValue", file);
      const response = await axios.post(
        "https://devapi.tech23.net/fileupload/uploadImage",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data; // Assuming the response contains the image URL
    } catch (error) {
      console.error("Error uploading image", error);
      return null;
    }
  };

  function handleRegister(e) {
    const vehiclepush =
      vehicleAllocated === undefined ? null : vehicleAllocated;
    e.preventDefault();
    setisloading(true);
    const formData = new FormData();
    // formData.append("data", JSON.stringify(formInput));
    // formData.append("EMPNO", empidPass);
    // formData.append("EMPCODE", formInput.EMPCODE);
    // formData.append("EMPNAME", formInput.EMPNAME);
    // formData.append("ACCOUNTNO", formInput.ACCOUNTNO);
    // formData.append("NATIONALID", formInput.NATIONALID);
    // formData.append("TELEPHONE", formInput.TELEPHONE);
    // formData.append("EMAIL", formInput.EMAIL);
    // formData.append("OVERTIME", formInput.OVERTIME);
    // formData.append("DESIGNATION", designation);
    // formData.append("DEPARTMENT", department);
    // formData.append("FREEZE", Number(formInput.FREEZE));
    // formData.append("VEHICLEALLOCATED", vehiclepush);
    // formData.append("CASUAL", Number(formInput.CASUAL));
    // formData.append("SUBCONTRACTED", Number(formInput.SUBCONTRACTED));
    // formData.append("CREATEDBY", LoggedInUserName);
    // formData.append("IMAGENAME", picture?.name);
    // formData.append("CONFIRM", Number(formInput.CONFIRM));
    // formData.append("NOTES", formInput.NOTES);
    // formData.append("PORTPASS", Number(formInput.PORTPASS));
    // formData.append("PORTPASSNO", formInput.PORTPASSNO);
    // formData.append("JOINDATE", JOINDATE);
    // formData.append("PORTPASSEXPIRY", PORTPASSPORTPASSEXPIRY);
    // formData.append("imageValue", picture);
    axios
      .post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=130`,
        {
          EMPNO: empidPass,
          EMPCODE: formInput.EMPCODE,
          EMPNAME: formInput.EMPNAME,
          ACCOUNTNO: formInput.ACCOUNTNO,
          NATIONALID: formInput.NATIONALID,
          TELEPHONE: formInput.TELEPHONE,
          EMAIL: formInput.EMAIL,
          OVERTIME: formInput.OVERTIME,
          DESIGNATION: designation,
          DEPARTMENT: department,
          FREEZE: Number(formInput.FREEZE),
          VEHICLEALLOCATED: vehiclepush,
          CASUAL: Number(formInput.CASUAL),
          SUBCONTRACTED: Number(formInput.SUBCONTRACTED),
          CREATEDBY: LoggedInUserName,
          IMAGENAME: picture?.name ? picture?.name : "",
          CONFIRM: Number(formInput.CONFIRM),
          NOTES: formInput.NOTES,
          PORTPASS: Number(formInput.PORTPASS),
          PORTPASSNO: formInput.PORTPASSNO,
          JOINDATE: JOINDATE ? moment(JOINDATE).format("YYYY/MM/DD") : "",
          PORTPASSEXPIRY: PORTPASSPORTPASSEXPIRY,
          IMAGE: image,
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        if (response.status === 201) {
          alert("Employee Saved Successfully");
          setisloading(false);
          window.location.reload();
        } else {
          alert(response.data.message);
          setisloading(false);
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log("Error While Saving SP : 130");
        alert("Error While Saving SP : 130");
        setisloading(false);
      });
  }

  const renderFilePreview = () => {
    if (fileUpload) {
      const fileType = fileUpload.type.split("/")[1];

      if (fileType === "pdf") {
        return (
          <embed
            src={URL.createObjectURL(fileUpload)}
            type="application/pdf"
            width="100%"
            height="500px"
          />
        );
      } else if (
        ["jpg", "jpeg", "png", "heic", "heif", "webp"].includes(fileType)
      ) {
        return <img src={URL.createObjectURL(fileUpload)} />;
      }

      return <p>Preview not available for this file type.</p>;
    }
  };
  if (isloading) {
    return <LoadingScreen />;
  }
  return (
    <div>
      <AllPagesNavbar />
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">{"Employee Registration"}</h1>
      </header>

      <div className="bg-slate-100 m-1 rounded-md p-1 pb-2 h-auto">
        {/* 1st Line */}
        <div className="lg:flex mt-2">
          <span className="block">Employee No :</span>
          <input
            readOnly
            className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            name="EMPNO"
            value={empidPass}
          ></input>

          <button
            className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              setShowEmployees(true);
            }}
          >
            ...
          </button>

          {showEmployees && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={searchEmployees}
                  onChange={(e) => {
                    setSearchEmployees(e.target.value);
                  }}
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowEmployees(false)}
              >
                Close
              </button>
              <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                <table className="w-full border border-gray-300 text-sm">
                  <thead className="sticky top-0">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Employee No
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Employee Code
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Employee Name
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Telephone
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Email
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        National Id
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Designation
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Department
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterEmployee?.map((item, index) => {
                      return (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            setEmpId(item?.[" EMPLOYEE ID"]);

                            setFormInput((prev) => ({
                              ...prev,
                              EMPCODE: item?.["EMPLOYEE CODE"] || "",
                              EMPNAME: item?.["EMPLOYEE NAME"] || "",
                              TELEPHONE: item?.["TELEPHONE NO"] || "",
                              EMAIL: item?.["EMAIL"] || "",
                              NATIONALID: item?.["NATIONAL ID NO"] || "",
                              JOINDATE: item?.["DATE JOINED"] || "",
                              FREEZE: item?.["EMPLOYEE FREEZE"] ?? 0,
                              OVERTIME: item?.["OVERTIME"] ?? 0,
                              ACCOUNTNO: item?.["ACCOUNTNO"] || "",
                              CASUAL: item?.["CASUAL"] ?? 1,
                              SUBCONTRACTED: item?.["SUBCONTRACTED"] ?? 0,
                              IMAGENAME: item?.["IMAGENAME"] || "",
                              CONFIRM: item?.["CONFIRM"] ?? 0,
                              NOTES: item?.["NOTES"] || "",
                              PORTPASS: item?.["PORTPASS"] ?? 0,
                              PORTPASSNO: item?.["PORTPASSNO"] || "",
                            }));
                            const selectedDesignation = desigVal.find(
                              (d) =>
                                d.OM_DESIGNATION_NAME === item?.["DESIGNATION"],
                            );
                            setDesignation(
                              selectedDesignation
                                ? {
                                    label:
                                      selectedDesignation.OM_DESIGNATION_NAME,
                                    value:
                                      selectedDesignation.OM_DESIGNATION_NAME,
                                  }
                                : null,
                            );
                            const selectedDepartment = DEPARTMENTVal.find(
                              (d) =>
                                d.OM_DEPARTMENT_NAME === item?.["DEPARTMENT"],
                            );
                            setDepartment(
                              selectedDepartment
                                ? {
                                    label:
                                      selectedDepartment.OM_DEPARTMENT_NAME,
                                    value:
                                      selectedDepartment.OM_DEPARTMENT_NAME,
                                  }
                                : null,
                            );
                            const selectedVehicle = vehicles.find(
                              (d) =>
                                d?.["VEHICLE ALLOCATED"] ===
                                item?.["VEHICLE REG NO"],
                            );
                            setVehicleAllocated(
                              selectedVehicle
                                ? {
                                    label:
                                      selectedVehicle?.["VEHICLE ALLOCATED"],
                                    value:
                                      selectedVehicle?.["VEHICLE ALLOCATED"],
                                  }
                                : null,
                            );
                            setShowEmployees(false);
                          }}
                          key={index}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item?.[" EMPLOYEE ID"]
                              ? item?.[" EMPLOYEE ID"]
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item?.["EMPLOYEE CODE"]
                              ? item?.["EMPLOYEE CODE"]
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item?.["EMPLOYEE NAME"]
                              ? item?.["EMPLOYEE NAME"]
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item?.["TELEPHONE NO"]
                              ? item?.["TELEPHONE NO"]
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.EMAIL ? item.EMAIL : "NA"}
                          </td>
                          <td className="py-2 px-4 border border-gray-300">
                            {item?.["NATIONAL ID NO"]
                              ? item?.["NATIONAL ID NO"]
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 border border-gray-300">
                            {item?.["DESIGNATION"]
                              ? item?.["DESIGNATION"]
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item?.["DEPARTMENT"] ? item?.["DEPARTMENT"] : "NA"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <span className="block lg:ml-6">Employee Code :</span>
          <input
            className="w-40 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            name="EMPCODE"
            value={formInput.EMPCODE}
            // onChange={(e) => handleInputItem(e)}
            readOnly
          ></input>

          <span className="block lg:ml-2">Employee Name :</span>
          <input
            className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            name="EMPNAME"
            value={formInput.EMPNAME}
            onChange={(e) => handleInputItem(e)}
          ></input>

          <span className="block lg:ml-2">Account No :</span>
          <input
            className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            name="ACCOUNTNO"
            value={formInput.ACCOUNTNO}
            onChange={(e) => handleInputItem(e)}
          ></input>
        </div>

        {/* 2nd line  */}
        <div className="lg:flex mt-2">
          <span className="block">Join Date:</span>
          <input
            type="date"
            name="JOINDATE"
            // max={new Date().toISOString().split("T")[0]}
            value={JOINDATE?.split("T")[0]}
            onChange={(e) => {
              // setJOINDATE(moment(e.target.value).format("YYYY/MM/DD"));
              setJOINDATE(e.target.value);
            }}
            className="w-36 h-8 border border-black lg:ml-10 p-2 rounded-md focus:outline-none focus:border-blue-500"
          ></input>
          <span className="block lg:ml-2">National Id :</span>
          <input
            className="w-44 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            name="NATIONALID"
            value={formInput.NATIONALID}
            onChange={(e) => handleInputItem(e)}
          ></input>
          <span className="block lg:ml-2">Telephone :</span>
          <input
            className="w-44 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="number"
            name="TELEPHONE"
            value={formInput.TELEPHONE}
            onChange={(e) => handleInputItem(e)}
            onInput={tofixnumber}
          ></input>
          <span className="block lg:ml-2">Email :</span>
          <input
            className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="EMAIL"
            name="EMAIL"
            value={formInput.EMAIL}
            onChange={(e) => handleInputItem(e)}
          ></input>
        </div>

        {/* 3rd line  */}
        <div className="lg:flex mt-2">
          <span className="block">Subcontracted :</span>
          <div className="radio_btn">
            <div>
              <input
                required
                className="radio"
                type="radio"
                name="SUBCONTRACTED"
                onChange={(e) => {
                  handleInputItem(e);
                  if (e.target.value === "0") {
                    // If SUBCONTRACTEDED is No, set CASUAL to Yes
                    setFormInput({
                      ...formInput,
                      SUBCONTRACTED: 0,
                      CASUAL: 1,
                    });
                  } else {
                    // If SUBCONTRACTEDED is Yes, set CASUAL to No
                    setFormInput({
                      ...formInput,
                      SUBCONTRACTED: 1,
                      CASUAL: 0,
                    });
                  }
                }}
                value={1}
                checked={formInput.SUBCONTRACTED === 1}
              />
              Yes
            </div>
            <div>
              <input
                required
                className="radio"
                type="radio"
                name="SUBCONTRACTED"
                onChange={(e) => {
                  handleInputItem(e);
                  if (e.target.value === "1") {
                    // If SUBCONTRACTEDED is Yes, set CASUAL to No
                    setFormInput({
                      ...formInput,
                      SUBCONTRACTED: 1,
                      CASUAL: 0,
                    });
                  } else {
                    // If SUBCONTRACTEDED is No, set CASUAL to Yes
                    setFormInput({
                      ...formInput,
                      SUBCONTRACTED: 0,
                      CASUAL: 1,
                    });
                  }
                }}
                value={0}
                checked={formInput.SUBCONTRACTED === 0}
              />
              No
            </div>
          </div>

          <span className="block">Overtime :</span>
          <div className="radio_btn">
            <div>
              <input
                className="radio"
                required
                type="radio"
                name="OVERTIME"
                onChange={(e) => handleInputItem(e)}
                value={Number(1)}
              />
              Yes
            </div>
            <div>
              <input
                className="radio"
                required
                type="radio"
                name="OVERTIME"
                defaultChecked={true}
                onChange={(e) => handleInputItem(e)}
                value={Number(0)}
              />
              No
            </div>
          </div>

          <span className="block">Casual :</span>
          <div className="radio_btn">
            <div>
              <input
                className="radio"
                required
                type="radio"
                name="CASUAL"
                onChange={(e) => {
                  handleInputItem(e);
                  if (e.target.value === "0") {
                    // If CASUAL is No, set SUBCONTRACTEDED to Yes
                    setFormInput({
                      ...formInput,
                      CASUAL: 0,
                      SUBCONTRACTED: 1,
                    });
                  } else {
                    // If CASUAL is Yes, set SUBCONTRACTEDED to No
                    setFormInput({
                      ...formInput,
                      CASUAL: 1,
                      SUBCONTRACTED: 0,
                    });
                  }
                }}
                value={1}
                checked={formInput.CASUAL === 1}
              />
              Yes
            </div>
            <div>
              <input
                className="radio"
                required
                type="radio"
                name="CASUAL"
                onChange={(e) => {
                  handleInputItem(e);
                  if (e.target.value === "1") {
                    // If CASUAL is Yes, set SUBCONTRACTEDED to No
                    setFormInput({
                      ...formInput,
                      CASUAL: 1,
                      SUBCONTRACTED: 0,
                    });
                  } else {
                    // If CASUAL is No, set SUBCONTRACTEDED to Yes
                    setFormInput({
                      ...formInput,
                      CASUAL: 0,
                      SUBCONTRACTED: 1,
                    });
                  }
                }}
                value={0}
                checked={formInput.CASUAL === 0}
              />
              No
            </div>
          </div>

          <span className="block">Freeze :</span>
          <div className="radio_btn">
            <div>
              <input
                className="radio"
                type="radio"
                name="FREEZE"
                onChange={(e) => handleInputItem(e)}
                value={Number(1)}
              />
              Yes
            </div>
            <div>
              <input
                className="radio"
                type="radio"
                name="FREEZE"
                defaultChecked={true}
                onChange={(e) => handleInputItem(e)}
                value={Number(0)}
              />
              No
            </div>
          </div>
          <span className="block">Confirm :</span>
          <div className="radio_btn">
            <div>
              <input
                className="radio"
                type="radio"
                name="CONFIRM"
                onChange={(e) => handleInputItem(e)}
                value={Number(1)}
              />
              Yes
            </div>
            <div>
              <input
                className="radio"
                type="radio"
                name="CONFIRM"
                onChange={(e) => handleInputItem(e)}
                value={Number(0)}
                defaultChecked={true}
              />
              No
            </div>
          </div>
        </div>

        {/* 4th line  */}
        <div className="lg:flex mt-2">
          <span className="block">Designation :</span>
          <Select
            className="input_field text-left uppercase lg:ml-3"
            value={
              designation
                ? {
                    value: designation,
                    label: designation,
                  }
                : { value: "", label: "Select Designation" }
            }
            onChange={setDesignation}
            options={desigVal.map((data) => ({
              label: data.OM_DESIGNATION_NAME,
              value: data.OM_DESIGNATION_NAME,
            }))}
          ></Select>

          <span className="block lg:ml-2">Department :</span>
          <Select
            className="input_field text-left uppercase lg:ml-2"
            value={
              department
                ? {
                    value: department,
                    label: department,
                  }
                : { value: "", label: "Select Department" }
            }
            onChange={setDepartment}
            options={DEPARTMENTVal.map((data) => ({
              label: data.OM_DEPARTMENT_NAME,
              value: data.OM_DEPARTMENT_NAME,
            }))}
          ></Select>

          <span className="block lg:ml-2">Vehicle Allocated :</span>
          <Select
            className="input_field text-left uppercase lg:ml-2"
            isDisabled={designation === "" || designation !== "DRIVER"}
            value={
              vehicleAllocated
                ? { label: vehicleAllocated, value: vehicleAllocated }
                : { label: "select", value: "" }
            }
            onChange={setVehicleAllocated}
            options={vehicles.map((vehi) => ({
              label: vehi["VEHICLE REG NO"],
              value: vehi["VEHICLE REG NO"],
            }))}
          />
        </div>

        <div className="lg:flex mt-5">
          <span className="block">Notes :</span>
          <textarea
            required
            rows={3}
            className="w-[500px] lg:ml-14"
            type="text"
            name="NOTES"
            defaultValue={formInput.NOTES}
            onChange={(e) => handleInputItem(e)}
          />
        </div>

        {/* 5th line */}

        <div className="lg:flex justify-between mt-2">
          <div className="flex">
            <div className="row">
              <div className="small-12 medium-2 large-2 columns">
                <div className="circle">
                  <div className="center__no__data">
                    <div>
                      <img
                        required
                        name="userImg"
                        style={{ fontFamily: "Cursive" }}
                        src={dispPicture}
                        alt="Upload image here"
                        className={dispPicture ? "img" : "profile_pic"}
                      />
                    </div>
                  </div>
                </div>
                <div className="camera_upload">
                  <div className="camera__icon">
                    <button
                      className="camera_btn"
                      onClick={() => {
                        const CONFIRMBox = window.confirm(
                          "Allow access to camera?",
                        );
                        if (CONFIRMBox === true) {
                          setSection1(false);
                          setCameraOn(true);
                          openCamera();
                        } else {
                          return null;
                        }
                      }}
                    >
                      {" "}
                      <p className="bg-green">
                        <FaCamera />
                      </p>
                    </button>
                  </div>
                  <div>
                    <input
                      style={{ padding: "5px", display: "none" }}
                      id="file"
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => {
                        handlePictureUpload(e);
                      }}
                    />
                    <div className="upload_file">
                      <label className="View" htmlFor="file">
                        Upload
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-5 lg:mt-40">
            <button
              // className="View button"
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                window.location.reload();
              }}
            >
              Reset
            </button>

            <button
              // className="View button bg-green"
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={(e) => {
                const emp = employeeList.find(
                  (item) => item["EMPLOYEE NAME"] == formInput.EMPNAME,
                );
                if (emp) {
                  alert("Employee Name already exists!");
                  return;
                }

                const CONFIRMBox = window.confirm(
                  "Are you sure all the details are correct?",
                );
                if (CONFIRMBox === true) {
                  handleRegister(e);
                } else {
                  e.preventDefault();
                }
              }}
            >
              Register
            </button>
          </div>
        </div>
      </div>

      {cameraOn ? (
        <div className="camera__align">
          <video ref={videoRef} />

          <button
            className="Capture"
            onClick={() => {
              capturePicture();
            }}
          >
            Capture
          </button>
          <canvas ref={canvasRef} />
        </div>
      ) : null}
      {captured ? (
        <div>
          <div>
            <img className="Image" src={dispPicture} />
          </div>

          <div className="camera_btn2">
            <button
              className="retake"
              onClick={() => {
                retakePicture();
              }}
            >
              Retake
            </button>
            <button
              className="Proceed"
              onClick={() => {
                setCameraOn(false);
                setCaptured(false);
                setSection1(true);
              }}
            >
              Proceed
            </button>
          </div>
        </div>
      ) : null}

      {/* {section1 ? (
        <form
          className="uppercase"
          onSubmit={(e) => {
            const CONFIRMBox = window.confirm(
              "Are you sure all the details are correct?",
            );
            if (CONFIRMBox === true) {
              handleRegister(e);
            } else {
              e.preventDefault();
            }
          }}
        >
          <div className="registration-form-container">
            <header className="header__of__main">
              <h1 className="header__of__page"> Employee Registration</h1>
            </header>
            <div className="row">
              <div className="small-12 medium-2 large-2 columns">
                <div className="circle">
                  <div className="center__no__data">
                    <div>
                      <img
                        required
                        name="userImg"
                        style={{ fontFamily: "Cursive" }}
                        src={dispPicture}
                        alt="Upload image here"
                        className={dispPicture ? "img" : "profile_pic"}
                      />
                    </div>
                  </div>
                </div>
                <div className="camera_upload">
                  <div className="camera__icon">
                    <button
                      className="camera_btn"
                      onClick={() => {
                        const CONFIRMBox = window.confirm(
                          "Allow access to camera?",
                        );
                        if (CONFIRMBox === true) {
                          setSection1(false);
                          setCameraOn(true);
                          openCamera();
                        } else {
                          return null;
                        }
                      }}
                    >
                      {" "}
                      <p className="bg-green">
                        <FaCamera />
                      </p>
                    </button>
                  </div>
                  <div>
                    <input
                      style={{ padding: "5px", display: "none" }}
                      id="file"
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => {
                        handlePictureUpload(e);
                      }}
                    />
                    <div className="upload_file">
                      <label className="View" htmlFor="file">
                        Upload
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Detials">
              <div>
                <label className="label">EMPLOYEE NO </label>
                <input
                  required
                  type="text"
                  name="EMPNO"
                  defaultValue={empidPass}
                  disabled
                  className="bg-white"
                />
              </div>
              <div>
                <label className="label">EMPLOYEE CODE</label>
                <input
                  required
                  type="text"
                  name="EMPCODE"
                  defaultValue={formInput.EMPCODE}
                  onChange={(e) => handleInputItem(e)}
                />
              </div>
              <div>
                <label className="label">EMPLOYEE NAME</label>
                <input
                  required
                  type="text"
                  name="EMPNAME"
                  defaultValue={formInput.EMPNAME}
                  onChange={(e) => handleInputItem(e)}
                />
              </div>
              <div>
                <label className="label">ACCOUNT NO</label>
                <input
                  required
                  type="text"
                  name="ACCOUNTNO"
                  defaultValue={formInput.ACCOUNTNO}
                  onChange={(e) => handleInputItem(e)}
                />
              </div>
              <div>
                <label className="label">JOIN DATE</label>
                <input
                  required
                  type="date"
                  name="JOINDATE"
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => {
                    setJOINDATE(moment(e.target.value).format("YYYY/MM/DD"));
                  }}
                />
              </div>
              <div>
                <label className="label">NATIONAL ID</label>
                <input
                  required
                  type="text"
                  name="NATIONALID"
                  defaultValue={formInput.NATIONALID}
                  onChange={(e) => handleInputItem(e)}
                />
              </div>
              <div>
                <label className="label">TELEPHONE</label>
                <input
                  required
                  type="number"
                  name="TELEPHONE"
                  defaultValue={formInput.TELEPHONE}
                  onChange={(e) => handleInputItem(e)}
                  onInput={tofixnumber}
                />
              </div>
              <div>
                <label className="label">EMAIL</label>
                <input
                  required
                  type="EMAIL"
                  name="EMAIL"
                  defaultValue={formInput.EMAIL}
                  onChange={(e) => handleInputItem(e)}
                />
              </div>
              <div>
                <label className="label">OVERTIME</label>
                <div className="radio_btn">
                  <div>
                    <input
                      className="radio"
                      required
                      type="radio"
                      name="OVERTIME"
                      onChange={(e) => handleInputItem(e)}
                      value={Number(1)}
                    />
                    Yes
                  </div>
                  <div>
                    <input
                      className="radio"
                      required
                      type="radio"
                      name="OVERTIME"
                      defaultChecked={true}
                      onChange={(e) => handleInputItem(e)}
                      value={Number(0)}
                    />
                    No
                  </div>
                </div>
              </div>
            </div>

            <div className="Info">
              <div>
                <label className="label">DESIGNATION</label>
                <Select
                  className="input_field text-left uppercase"
                  required
                  defaultValue={designation}
                  onChange={setDesignation}
                  options={desigVal.map((data) => ({
                    label: data.OM_DESIGNATION_NAME,
                    value: data.OM_DESIGNATION_NAME,
                  }))}
                />
              </div>
              <div>
                <label className="label">DEPARTMENT</label>
                <Select
                  className="input_field text-left uppercase"
                  required
                  defaultValue={department}
                  onChange={setDepartment}
                  options={DEPARTMENTVal.map((data) => ({
                    label: data.OM_DEPARTMENT_NAME,
                    value: data.OM_DEPARTMENT_NAME,
                  }))}
                />
              </div>
              <div>
                <label className="label">FREEZE</label>
                <div className="radio_btn">
                  <div>
                    <input
                      className="radio"
                      type="radio"
                      name="FREEZE"
                      onChange={(e) => handleInputItem(e)}
                      value={Number(1)}
                    />
                    Yes
                  </div>
                  <div>
                    <input
                      className="radio"
                      type="radio"
                      name="FREEZE"
                      defaultChecked={true}
                      onChange={(e) => handleInputItem(e)}
                      value={Number(0)}
                    />
                    No
                  </div>
                </div>
              </div>
              <div>
                <label className="label">VEHICLE ALLOCATED</label>
                <Select
                  className="input_field text-left uppercase"
                  isDisabled={designation === "" || designation !== "DRIVER"}
                  value={
                    vehicleAllocated
                      ? { label: vehicleAllocated, value: vehicleAllocated }
                      : { label: "select", value: "" }
                  }
                  onChange={setVehicleAllocated}
                  options={vehicles.map((vehi) => ({
                    label: vehi["VEHICLE REG NO"],
                    value: vehi["VEHICLE REG NO"],
                  }))}
                />
              </div>
              <div>
                <label className="label">CASUAL</label>
                <div className="radio_btn">
                  <div>
                    <input
                      className="radio"
                      required
                      type="radio"
                      name="CASUAL"
                      onChange={(e) => {
                        handleInputItem(e);
                        if (e.target.value === "0") {
                          setFormInput({
                            ...formInput,
                            CASUAL: 0,
                            SUBCONTRACTED: 1,
                          });
                        } else {
                          setFormInput({
                            ...formInput,
                            CASUAL: 1,
                            SUBCONTRACTED: 0,
                          });
                        }
                      }}
                      value={1}
                      checked={formInput.CASUAL === 1}
                    />
                    Yes
                  </div>
                  <div>
                    <input
                      className="radio"
                      required
                      type="radio"
                      name="CASUAL"
                      onChange={(e) => {
                        handleInputItem(e);
                        if (e.target.value === "1") {
                          setFormInput({
                            ...formInput,
                            CASUAL: 1,
                            SUBCONTRACTED: 0,
                          });
                        } else {
                          setFormInput({
                            ...formInput,
                            CASUAL: 0,
                            SUBCONTRACTED: 1,
                          });
                        }
                      }}
                      value={0}
                      checked={formInput.CASUAL === 0}
                    />
                    No
                  </div>
                </div>
              </div>
              <div>
                <label className="label">SUBCONTRACTED</label>
                <div className="radio_btn">
                  <div>
                    <input
                      required
                      className="radio"
                      type="radio"
                      name="SUBCONTRACTED"
                      onChange={(e) => {
                        handleInputItem(e);
                        if (e.target.value === "0") {
                          setFormInput({
                            ...formInput,
                            SUBCONTRACTED: 0,
                            CASUAL: 1,
                          });
                        } else {
                          setFormInput({
                            ...formInput,
                            SUBCONTRACTED: 1,
                            CASUAL: 0,
                          });
                        }
                      }}
                      value={1}
                      checked={formInput.SUBCONTRACTED === 1}
                    />
                    Yes
                  </div>
                  <div>
                    <input
                      required
                      className="radio"
                      type="radio"
                      name="SUBCONTRACTED"
                      onChange={(e) => {
                        handleInputItem(e);
                        if (e.target.value === "1") {
                          setFormInput({
                            ...formInput,
                            SUBCONTRACTED: 1,
                            CASUAL: 0,
                          });
                        } else {
                          setFormInput({
                            ...formInput,
                            SUBCONTRACTED: 0,
                            CASUAL: 1,
                          });
                        }
                      }}
                      value={0}
                      checked={formInput.SUBCONTRACTED === 0}
                    />
                    No
                  </div>
                </div>
              </div>
              <div>
                <label className="label">CONFIRM </label>
                <div className="radio_btn">
                  <div>
                    <input
                      className="radio"
                      type="radio"
                      name="CONFIRM"
                      onChange={(e) => handleInputItem(e)}
                      value={Number(1)}
                    />
                    Yes
                  </div>
                  <div>
                    <input
                      className="radio"
                      type="radio"
                      name="CONFIRM"
                      onChange={(e) => handleInputItem(e)}
                      value={Number(0)}
                      defaultChecked={true}
                    />
                    No
                  </div>
                </div>
              </div>
              <div className="textarea_NOTES">
                <label className="label"> NOTES</label>
                <textarea
                  required
                  className="Note"
                  type="text"
                  name="NOTES"
                  defaultValue={formInput.NOTES}
                  onChange={(e) => handleInputItem(e)}
                />
              </div>
              
              {filePreview ? <div>{renderFilePreview()}</div> : null}
            </div>
            <div className="nxt">
              <button
                className="View button"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Reset
              </button>

              <button className="View button bg-green" type="submit">
                Register
              </button>
            </div>
          </div>
        </form>
      ) : null} */}
    </div>
  );
};

export default EmployeeMaster;
